module.exports = "<div class=\"embed-responsive-item video-html\">\n  <div id=\"<%= playerId %>\"></div>\n</div>\n"